// extracted by mini-css-extract-plugin
export var hideEditor = "_ld-2";
export var infoIcon = "_ld-3";
export var label = "_ld-1";
export var labelContainer = "_ld-0";
export var readonlyText = "_ld-4";